import { Controller, useFieldArray, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { DataType } from 'types';
import { Button } from 'components/shadcn/button';
import { Input } from 'components/shadcn/input';
import { Label } from 'components/shadcn/label';
import {
  Select,
  SelectTrigger,
  SelectContent,
  SelectItem,
  SelectValue,
} from 'components/shadcn/select';
import { Plus, Trash2 } from 'lucide-react';

export const ExtractedDataFieldRepeater = () => {
  const { t } = useTranslation();
  const { control } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'dataToExtract',
  });

  return (
    <div>
      {fields.map((field, index) => (
        <div key={field.id} className="grid grid-cols-1 md:grid-cols-12 gap-2 mb-2 items-center">
          <div className="col-span-1 md:col-span-4">
            <Label htmlFor={`dataToExtract.${index}.name`} className="mb-1 block">
              {t('dashboard.dataToExtract.fieldName')}
            </Label>
            <Controller
              name={`dataToExtract.${index}.name`}
              control={control}
              render={({ field }) => (
                <Input id={`dataToExtract.${index}.name`} {...field} className="w-full" />
              )}
            />
          </div>

          <div className="col-span-1 md:col-span-4">
            <Label htmlFor={`dataToExtract.${index}.description`} className="mb-1 block">
              {t('dashboard.dataToExtract.description')}
            </Label>
            <Controller
              name={`dataToExtract.${index}.description`}
              control={control}
              render={({ field }) => (
                <Input id={`dataToExtract.${index}.description`} {...field} className="w-full" />
              )}
            />
          </div>

          <div className="col-span-1 md:col-span-3">
            <Label htmlFor={`dataToExtract.${index}.dataType`} className="mb-1 block">
              {t('dashboard.dataToExtract.dataType')}
            </Label>
            <Controller
              name={`dataToExtract.${index}.dataType`}
              control={control}
              render={({ field }) => (
                <Select value={field.value} onValueChange={field.onChange}>
                  <SelectTrigger className="w-full">
                    <SelectValue placeholder={t('dashboard.dataToExtract.selectDataType')} />
                  </SelectTrigger>
                  <SelectContent>
                    {Object.values(DataType).map((type) => (
                      <SelectItem key={type} value={type}>
                        {type}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
            />
          </div>

          <div className="col-span-1 md:col-span-1 flex justify-center md:justify-end md:pt-6">
            <Button
              variant="ghost"
              size="icon"
              onClick={() => remove(index)}
              className="text-destructive"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
        </div>
      ))}

      <div className="mt-2">
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={() => append({ name: '', description: '', dataType: DataType.STRING })}
          className="flex items-center gap-2"
        >
          <Plus className="h-4 w-4" />
          <span>{t('dashboard.dataToExtract.addField')}</span>
        </Button>
      </div>
    </div>
  );
};
